export interface CabecalhoRomaneio {
  CZ00COD: string;
  CZ00ORIGEM: string;
  CZ00DESTIN: string;
  CZ00STATUS: string;
  CZ00DATA: Date | undefined;
  CZ00HORA: string;
  CZ00USER: string;
  CUSRNOME: string;
  NZ00PESLIQ: number;
  CZ00PLACA: string;
  CEE7PEDIDO: string;
  CEE7PEDFAT: string;
  NEE7PESLI: number;
  NPESOTOT: number;
  AURS: Array<URLista>;
  CZ07CODIGO: string;
  CZ07STATUS: string;
  DZ00DTACAR: Date | undefined;
  CZ00HRACAR: string;
  CZ00MENNOT: string;
  itemsRomaneio: Array<ExpedicaoRomaneioItemDto>;
};

export const defaultCabecalhoRomaneio = (): CabecalhoRomaneio => {
  return {
    CZ00COD: '',
    CZ00ORIGEM: '',
    CZ00DESTIN: '',
    CZ00STATUS: '',
    CZ00DATA: undefined,
    CZ00HORA: '',
    CZ00USER: '',
    CUSRNOME: '',
    NZ00PESLIQ: 0,
    CZ00PLACA: '',
    CEE7PEDIDO: '',
    CEE7PEDFAT: '',
    NEE7PESLI: 0,
    NPESOTOT: 0,
    AURS: [],
    CZ07CODIGO: '',
    CZ07STATUS: '',
    DZ00DTACAR: undefined,
    CZ00HRACAR: '',
    CZ00MENNOT: '',
    itemsRomaneio: []
  };
};

export interface RomaneioDto extends CabecalhoRomaneio {
  items: Array<RomaneioItem>;
  itemsRecebidos: Array<ExpedicaoRomaneioItemDto>;
};
export interface RomaneioCompletoDto extends CabecalhoRomaneio {
  items: Array<RomaneioItem>;
  itemsRecebidos: Array<ExpedicaoRomaneioItemCompletoDto>;
};

export const defaultRomaneioDto = (): RomaneioDto => {
  return {
    CZ00COD: '',
    CZ00ORIGEM: '',
    CZ00DESTIN: '',
    CZ00STATUS: '',
    CZ00DATA: undefined,
    CZ00HORA: '',
    CZ00USER: '',
    CUSRNOME: '',
    NZ00PESLIQ: 0,
    CZ00PLACA: '',
    CEE7PEDIDO: '',
    CEE7PEDFAT: '',
    NEE7PESLI: 0,
    NPESOTOT: 0,
    AURS: [],
    CZ07CODIGO: '',
    CZ07STATUS: '',
    DZ00DTACAR: undefined,
    CZ00HRACAR: '',
    CZ00MENNOT: '',
    itemsRomaneio: [],
    items: [defaultRomaneioItem()],
    itemsRecebidos: [defaultExpedicaoRomaneioItemDto()],
  };
};


export interface RomaneioLista {
  items: Array<CabecalhoRomaneio>;
};

export const defaultRomaneioLista = (): RomaneioLista => {
  return {
    items: [defaultCabecalhoRomaneio()],
  };
};

export interface RomaneioItem {
  CZ01ETIQ: string;
  CZ01STSCAR: string;
  CB1COD: string;
  CB1DESC: string;
  CB1XFAM: string;
  NZ01QUANT: number;
  CZ02COD: string;
  CZ02STATUS: string;
  NZ02PESO: number;
  CTEMRECEBIDO: string;
  favorite: Array<string>;
  $selected: boolean;
};

export const defaultRomaneioItem = (): RomaneioItem => {
  return {
    CZ01ETIQ: '',
    CZ01STSCAR: '',
    CB1COD: '',
    CB1DESC: '',
    CB1XFAM: '',
    NZ01QUANT: 0,
    CZ02STATUS: '',
    CZ02COD: '',
    NZ02PESO: 0,
    CTEMRECEBIDO: 'N',
    favorite: [],
    $selected: false,
  };
};

export interface RomaneioItemLista {
  items: Array<RomaneioItem>
};

export const defaultRomaneioItemLista = (): RomaneioItemLista => {
  return {
    items: [defaultRomaneioItem()],
  };
};

export interface ExpedicaoRomaneioItemDto {
  CZ02COD: string;
  CZ02CODZ00: string;
  CZ02LOTE: string;
  NZ02PESO: number;
  CZ02PRAT: string;
  CZ02UR: string;
  CB1COD: string;
  CB1DESC: string;
  CB1XFAM: string;
  NZ01QUANT: number;
  CZ02INFORM: string;
  NZ05RECNO: number;
  CC5NUM: number;
  NQTDORI2: number;
  NM3PALLET: number;
  NB1CONV: number;
  CSTATUS: string;
  favorite: Array<string>;
};


export interface ExpedicaoRomaneioItemListaDto {
  items: Array<ExpedicaoRomaneioItemDto>;
};


export const defaultExpedicaoRomaneioItemListaDto = (): ExpedicaoRomaneioItemListaDto => {
  return {
    items: []
  };
};


export interface ExpedicaoRomaneioItemCompletoDto extends ExpedicaoRomaneioItemDto {
  CB1RTL: string;
  CB8LOCAL: string;
  CD3OP: string;
  NZ02NPACOT: number;
  CA1NOME: string;
  CC5PEDGER: string;
  CC5NOTA: string;
  CC5PEDEXP: string;
  CPROD02PEDCLI: string;
};


export const defaultExpedicaoRomaneioItemDto = (): ExpedicaoRomaneioItemDto => {
  return {
    CZ02COD: '',
    CZ02CODZ00: '',
    CZ02LOTE: '',
    CZ02PRAT: '',
    CZ02UR: '',
    NZ02PESO: 0,
    NZ01QUANT: 0,
    CB1COD: '',
    CB1DESC: '',
    CB1XFAM: '',
    CZ02INFORM: '',
    NZ05RECNO: 0,
    CC5NUM: 0,
    NQTDORI2: 0,
    NM3PALLET:0,
    NB1CONV: 0,
    CSTATUS: '',
    favorite: []
  };
};

export interface ExpedicaoRomaneioItemPedidoDto {
  CZ02COD: string;
  CZ02CODZ00: string;
  CZ02LOTE: string;
  NZ02VOLUME: number;
  NZ02CTNR: number;
  CZ02STATUS: string;
  CB1COD: string;
  CB1DESC: string;
  CC5NUM: string;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CA1NOME: string;
  CZ02UR: string;
  NZ05RECNO: number;
};

export const defaultExpedicaoRomaneioItemPedidoDto = (): ExpedicaoRomaneioItemPedidoDto => {
  return {
    CZ02COD: '',
    CZ02CODZ00: '',
    CZ02LOTE: '',
    NZ02VOLUME: 0,
    NZ02CTNR: 0,
    CB1COD: '',
    CB1DESC: '',
    CC5NUM: '',
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    CA1NOME: '',
    CZ02UR: '',
    CZ02STATUS: '',
    NZ05RECNO: 0,
  };
};

export interface PedidoItemExpedicaoDto {
  CZ03COD: string;
  CZ03LOTE: string;
  CZ03MOTIVO: string;
  DZ03EMISSA: Date | undefined;
  CZ03OBS: string;
  DZ03DTRET: Date | undefined;
  CZ02COD: string;
  CZ02CODZ00: string;
  CZ02LOTE: string;
  CC5NUM: string;
  CC5EMISSAO: Date | undefined;
  CC6ITEM: string;
  CC6PRODUTO: string;
  CC6DESCRI: string;
  NC6QTDVEN: number;
  NZ01QUANT: number;
  REGSC6: number;
  qtdVinculadaEtiqueta: number;
  qtdVinculadaItem: number;
  CMOTIVODESC: string;
};

export const defaultPedidoItemExpedicaoDto = (): PedidoItemExpedicaoDto => {
  return {
    CZ03COD: '',
    CZ03LOTE: '',
    CZ03MOTIVO: '',
    DZ03EMISSA: undefined,
    CZ03OBS: '',
    DZ03DTRET: undefined,
    CZ02COD: '',
    CZ02CODZ00: '',
    CZ02LOTE: '',
    CC5NUM: '',
    CC5EMISSAO: undefined,
    CC6ITEM: '',
    CC6PRODUTO: '',
    CC6DESCRI: '',
    NC6QTDVEN: 0,
    NZ01QUANT: 0,
    REGSC6: 0,
    qtdVinculadaEtiqueta: 0,
    qtdVinculadaItem: 0,
    CMOTIVODESC: '',
  };
};

export interface PedidoItemExpedicaoDtoLista {
  items: Array<PedidoItemExpedicaoDto>
};

export const defaultPedidoItemExpedicaoDtoLista = (): PedidoItemExpedicaoDtoLista => {
  return {
    items: [],
  };
};

export interface CabecalhoRomaneioCliente {
  CZ00COD: string;
  CZ00ORIGEM: string;
  CZ00DESTIN: string;
  CZ00STATUS: string;
  CZ00STATUSDESC: string;
  DZ00DATA: Date | undefined;
  CZ00HORA: string;
  DZ00DTACAR: Date | undefined;
  CZ00HRACAR: string;
  CZ00USER: string;
  CUSRNOME: string;
  CZ00PLACA: string;
  CZ00COTNER: string;
  CZ00PROCES: string;
  NZ00PESLIM: number;
  CZ00FRETCP: string;
  CZ00CAMICP: string;
  CZ00NCERT: string;
  CZ00PEDGER: string;
  NZ00TARA: number;
  CZ00SELOD: string;
  CZ00SELOP: string;
  CZ00CLIENT: string;
  CZ00LOJA: string;
  CA1NOME: string;
  DZ00DTLIB: Date | undefined;
  CZ00TERMIN: string;
  DZ00DTETER: Date | undefined;
  DZ00DTEPOR: Date | undefined;
  CZ00HRLIB: string;
  CZ00GRPVEN: string;
  CACYDESCRI: string;
  CDELETAR: string;
  CLOTEEXCLUSAO: string;
  NQTDZ02UR: number;
  AURS: Array<URLista>
};

export const defaultCabecalhoRomaneioCliente = (): CabecalhoRomaneioCliente => {
  return {
    CZ00COD: '',
    CZ00ORIGEM: '',
    CZ00DESTIN: '',
    CZ00STATUS: '',
    CZ00STATUSDESC: '',
    DZ00DATA: undefined,
    CZ00HORA: '',
    DZ00DTACAR: undefined,
    CZ00HRACAR: '',
    CZ00USER: '',
    CUSRNOME: '',
    CZ00PLACA: '',
    CZ00COTNER: '',
    CZ00PROCES: '',
    NZ00PESLIM: 0,
    CZ00FRETCP: '',
    CZ00CAMICP: '',
    CZ00NCERT: '',
    CZ00PEDGER: '',
    NZ00TARA: 0,
    CZ00SELOD: '',
    CZ00SELOP: '',
    CZ00CLIENT: '',
    CZ00LOJA: '',
    CA1NOME: '',
    DZ00DTLIB: undefined,
    CZ00TERMIN: '',
    DZ00DTETER: undefined,
    DZ00DTEPOR: undefined,
    CZ00HRLIB: '',
    CZ00GRPVEN: '',
    CACYDESCRI: '',
    CDELETAR: '',
    CLOTEEXCLUSAO: '',
    NQTDZ02UR: 0,
    AURS: [],
  };
};

export interface Dano {
  CZ03DESMONTE: string;
  CZ03LTRET : string;
  CZ03OBSRT: string;
  CZ03RETLT: string;
  CZ02COD: string;
  CZ03COD: string;
  CZ03LOTE: string;
  CZ02LOTE: string;
  CZ03MOTIVO: string;
  DZ03EMISSA: Date | undefined;
  CZ03OBS: string;
  DZ03DTRET: Date | undefined;
  CZ02CODZ00: string;
  CB1COD: string;
  CB1DESC: string;
  CC5NUM: string;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CA1NOME: string;
  NB8QTDORI: number;
  NB8QTDORIRET: number;
  CMOTIVODESC: string;
  CZ03ENVLOT: string;
  CZ03RESPON: string;
  CRESPONSAVEL: string;
};

export const defaultDano = (): Dano => {
  return {
    CZ03LTRET: '',
    CZ03DESMONTE: '',
    CZ03OBSRT: '',
    CZ03RETLT: '',
    CZ02COD: '',
    CZ03COD: '',
    CZ03LOTE: '',
    CZ02LOTE: '',
    CZ03MOTIVO: '',
    DZ03EMISSA: undefined,
    CZ03OBS: '',
    DZ03DTRET: undefined,
    CZ02CODZ00: '',
    CB1COD: '',
    CB1DESC: '',
    CC5NUM: '',
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    CA1NOME: '',
    NB8QTDORI: 0,
    NB8QTDORIRET: 0,
    CMOTIVODESC: '',
    CZ03ENVLOT: '',
    CZ03RESPON: '',
    CRESPONSAVEL: '',
  };
}

export interface DanosLista {
  items: Array<Dano>
};


export interface RomaneioClienteDto extends CabecalhoRomaneioCliente {
  pedidos: Array<PedidoLote>;
  itemsSelecionados: Array<RomaneioClienteItem>;
};

export const defaultRomaneioClienteDto = (): RomaneioClienteDto => {
  return {
    CZ00COD: '',
    CZ00ORIGEM: '',
    CZ00DESTIN: '',
    CZ00STATUS: '',
    CZ00STATUSDESC: '',
    DZ00DATA: undefined,
    CZ00HORA: '',
    DZ00DTACAR: undefined,
    CZ00HRACAR: '',
    CZ00USER: '',
    CUSRNOME: '',
    CZ00PLACA: '',
    CZ00COTNER: '',
    CZ00PROCES: '',
    NZ00PESLIM: 0,
    CZ00FRETCP: '',
    CZ00CAMICP: '',
    CZ00NCERT: '',
    CZ00PEDGER: '',
    NZ00TARA: 0,
    CZ00SELOD: '',
    CZ00SELOP: '',
    CZ00CLIENT: '',
    CZ00LOJA: '',
    CA1NOME: '',
    DZ00DTLIB: undefined,
    CZ00TERMIN: '',
    DZ00DTETER: undefined,
    DZ00DTEPOR: undefined,
    CZ00HRLIB: '',
    CZ00GRPVEN: '',
    CACYDESCRI: '',
    CDELETAR: '',
    CLOTEEXCLUSAO: '',
    NQTDZ02UR: 0,
    AURS: [],
    pedidos: [],
    itemsSelecionados: [],
  };
};

export interface PedidoLote {
  status: string;
  CEE7PEDIDO: string;
  CZ02PEDIDO: string;
  CC5CLIENTE: string;
  CC5LOJACLI: string;
  CTIPO: string;
  NEE7PESOLI: number;
  lotes: Array<RomaneioClienteItem>;
};

export const defaultPedidoLote = (): PedidoLote => {
  return {
    status: 'P',
    CEE7PEDIDO: '',
    CZ02PEDIDO: '',
    CC5CLIENTE: '',
    CC5LOJACLI: '',
    CTIPO: '',
    NEE7PESOLI: 0,
    lotes: []
  };
};


export interface RomaneioClienteItem {
  contador: number;
  status: string;
  CZ02PEDIDO: string;
  NZ02PESO: number;
  CZ02PRAT: string;
  CZ02LOTE: string;
  CZ02CTNR: number;
  CB1COD: string;
  CB1DESC: string;
  CZ02PACOT: string;
  CZ02COD: string;
  CZ02INFORM: string;
  CZ02UR: string;
  NB8SALDO: number;
  NZ01QUANT: number;
  NSOMAQTDVEN: number;
  NSOMAQTDENT: number;
  NQTDVINCROMANEIO: number;
  NQTDVINCTOTAL: number;
  CZ00DATA: string;
  favorite: Array<string>;
};

export const defaultRomaneioClienteItem = (): RomaneioClienteItem => {
  return {
    contador: 0,
    status: 'P',
    CZ02PEDIDO: '',
    NZ02PESO: 0,
    CZ02PRAT: '',
    CZ02LOTE: '',
    CZ02CTNR: 0,
    CB1COD: '',
    CB1DESC: '',
    CZ02PACOT: '',
    CZ02COD: '',
    CZ02INFORM: '',
    CZ02UR: '',
    NZ01QUANT: 0,
    NB8SALDO:0,
    NSOMAQTDVEN: 0,
    NSOMAQTDENT: 0,
    NQTDVINCROMANEIO: 0,
    NQTDVINCTOTAL: 0,
    CZ00DATA: '',
    favorite: [],
  };
};

export interface RetornoRetornarPendente {
  lSuccess: boolean;
  cTipoErro: string;
};

export interface RelatorioBaldeioItem {
  DZ00DATABX: Date | undefined;
  CZ00HORABX: string;
  CZ00COD: string;
  CZ00DESTIN: string;
  CZ00STATUS: string;
  DZ00DATA: Date | undefined;
  CZ00HORA: string;
  DZ00DTFIM: Date | undefined;
  CZ00HRFIM: string;
  CZ00PLACA: string;
  CZ00COTNER: string;
  CZ00PROCES: string;
  CZ00CAMICP: string;
  NZ00TARA: number;
  CZ00SELOD: string;
  CZ00SELOP: string;
  CZ00CLIENT: string;
  CZ00LOJA: string;
  CZ00NCERT: string;
  CZ00NOTA: string;
  NZ00CONT: number;
  CA1NOME: string;
};

export interface RelatorioBaldeioLista {
  items: Array<RelatorioBaldeioItem>
};

export interface RelatorioLotesItem {

  CZ02LOTE: string;
  NZ02PESO: string;
  CZ02PRAT: string;
  CZ02STATUS: string;
  CZ02PEDIDO: string;
  CZ02PEDDES: string;
  NZ02NPACOT: string;
  CZ02INFORM: string;
  CZ02UR: string;
  NZ02VOLUME: string;
  NZ02CTNR: string;
  CEE7PEDIDO: string;
};

export interface RelatorioLotesLista {
  items: Array<RelatorioLotesItem>
};

export interface RelatorioMIItem {
  CZ02PEDIDO: string;
  CZ02LOTE: string;
  CB1COD: string;
  CB1DESC: string;
  CZ00COD: string;
  CZ00DESTIN: string;
  CZ02PEDDES: string;
  CZ01QUANT: number;
  CC6PRCVEN: number;
  CC6UNSVLR: number;
  CB8QTDORI2: number;
};

export interface RelatorioMILista {
  items: Array<RelatorioMIItem>
};

export interface RelatorioInconsistenciasItem {
  CTIPO: string;
  CZ02LOTE: string;
  CZ02PEDIDO: string;
  NZ02PESO: number;
  CZ02COD: string;
  CZ02PRAT: string;
  CZ02UR: string;
  CZ02INFORM: string;
};

export interface RelatorioInconsistenciasLista {
  items: Array<RelatorioInconsistenciasItem>
};


export interface TransferenciaPedidoParaPedidoItem {
  CZ02CODORI: string;
  CZ02LOTE: string;
  CZ02CODDEST: string;
};

export interface TransferenciaPedidoParaPedidoLista {
  items: Array<TransferenciaPedidoParaPedidoItem>
};

export interface TransferenciaPedidoParaPedidoFiltro {
  CZ02PEDIDO: string;
  CEE7PEDIDO: string;
  CFILTRO: string;
};

export const defaultTransferenciaPedidoParaPedidoFiltro = (): TransferenciaPedidoParaPedidoFiltro => {
  return {
    CZ02PEDIDO: '',
    CEE7PEDIDO: '',
    CFILTRO: '',
  };
};

export interface UR {
  CZ05COD: string;
  CZ05UR: string;
  NZ05VOLUME: number;
  NZ05SALDO: number;
  CZ05TIPO: string;
  CZ05BLOQ: string;
  NZ05RECNO: number;
};

export interface URLista {
  items: Array<UR>;
};

export const defaultUR = (): UR => {
  return {
    CZ05COD: '',
    CZ05UR: '',
    NZ05VOLUME: 0,
    NZ05SALDO: 0,
    CZ05TIPO: '',
    CZ05BLOQ: '',
    NZ05RECNO: 0,
  };
};

export interface FiltroUR {
  CZ05COD: string;
  CZ05UR: string;
  CZ05TIPO: string;
  CZ05BLOQ: string;
};

export const defaultFiltroUR = (): FiltroUR => {
  return {
    CZ05COD: '',
    CZ05UR: '',
    CZ05TIPO: ' ',
    CZ05BLOQ: ' ',
  };
};

export interface RomaneioInfCertificado {
  UR: string;
  CZ02UR: string;
  CZEXTKD: string;
  CZEXTEC: string;
  CZEXINF: string;
  CZ00COD: string;
  CZ00NCERT: string;
  NQTDZ02UR: number;
  $selected: boolean;
};

export const defaultRomaneioInfCertificado = (): RomaneioInfCertificado => {
  return {
    UR: '',
    CZ02UR: '',
    CZEXTKD: '',
    CZEXTEC: '',
    CZEXINF: '',
    CZ00COD: '',
    CZ00NCERT: '',
    NQTDZ02UR: 0,
    $selected: false,
  };
};

export interface URRomaneioLista {
  UR: string;
};

export interface ProgramacaoCarregamento {
  CZ00COD: string;
  CZ00ORIGEM: string;
  CZ00DESTIN: string;
  CZ00STATUS: string;
  CZ00STATUSDESC: string;
  DZ00DATA: Date | undefined;
  CZ00HORA: string;
  DZ00DTACAR: Date | undefined;
  CZ00HRACAR: string;
  CZ00USER: string;
  CUSRNOME: string;
  CZ00PLACA: string;
  CZ00COTNER: string;
  CZ00PROCES: string;
  NZ00PESLIM: number;
  CZ00FRETCP: string;
  CZ00CAMICP: string;
  CZ00NCERT: string;
  CZ00PEDGER: string;
  NZ00TARA: number;
  CZ00SELOD: string;
  CZ00SELOP: string;
  CZ00CLIENT: string;
  CZ00LOJA: string;
  CA1NOME: string;
  DZ00DTLIB: Date | undefined;
  CZ00HRLIB: string;
  CZ00GRPVEN: string;
  CACYDESCRI: string;
  CDELETAR: string;
  CLOTEEXCLUSAO: string;
  NQTDZ02UR: number;
  AURS: Array<URLista>
  CZ07CODIGO: string;
  CZ07STATUS: string;
  $selected: boolean,
};

export const defaultProgramacaoCarregamento = (): ProgramacaoCarregamento => {
  return {
    CZ00COD: '',
    CZ00ORIGEM: '',
    CZ00DESTIN: '',
    CZ00STATUS: '',
    CZ00STATUSDESC: '',
    DZ00DATA: undefined,
    CZ00HORA: '',
    DZ00DTACAR: undefined,
    CZ00HRACAR: '',
    CZ00USER: '',
    CUSRNOME: '',
    CZ00PLACA: '',
    CZ00COTNER: '',
    CZ00PROCES: '',
    NZ00PESLIM: 0,
    CZ00FRETCP: '',
    CZ00CAMICP: '',
    CZ00NCERT: '',
    CZ00PEDGER: '',
    NZ00TARA: 0,
    CZ00SELOD: '',
    CZ00SELOP: '',
    CZ00CLIENT: '',
    CZ00LOJA: '',
    CA1NOME: '',
    DZ00DTLIB: undefined,
    CZ00HRLIB: '',
    CZ00GRPVEN: '',
    CACYDESCRI: '',
    CDELETAR: '',
    CLOTEEXCLUSAO: '',
    NQTDZ02UR: 0,
    AURS: [],
    CZ07CODIGO: '',
    CZ07STATUS: '',
    $selected: false,
  };
};

export interface ProgramacaoCarregamentoLista {
  CZ07CODIGO: string;
  CZ07STATUS: string;
  DZ07DATINC: Date | undefined;
  CZ07HORINC: string;
  CUSERINCNM: string;
  DZ07DTFIM: Date | undefined;
  CZ07HRFIM: string;
  NQTDZ00: number;
  NZ07RECNO: number;
  COPERACAO: string;
  label: string;
  value: string;
};

export interface ProgramacaoCarregamentoItems {
  items: Array<ProgramacaoCarregamentoLista>;
};

export const defaultProgramacaoCarregamentoLista = (): ProgramacaoCarregamentoLista => {
  return {
    CZ07CODIGO: '',
    CZ07STATUS: '',
    DZ07DATINC: undefined,
    CZ07HORINC: '',
    CUSERINCNM: '',
    DZ07DTFIM: undefined,
    CZ07HRFIM: '',
    NQTDZ00: 0,
    NZ07RECNO: 0,
    COPERACAO: '',
    label: '',
    value: '',
  };
};

export interface RomaneioNFItem {
  CD1COD: string;
  CD1UM: string;
  ND1QUANT: number;
  ND1VUNIT: number;
  ND1TOTAL: number;
  CD1LOTECTL: string;
  CB1DESC: string;
  NB8SALDO: number;
};

export interface RomaneioNF {
  CF1DOC: string;
  CF1SERIE: string;
  CF1FORNECE: string;
  CF1LOJA: string;
  DF1EMISSAO: Date | undefined;
  items: Array<RomaneioNFItem>;
};

export const getDefaultRomaneioNF = (): RomaneioNF => {
  return {
    CF1DOC: '',
    CF1SERIE: '',
    CF1FORNECE: '',
    CF1LOJA: '',
    DF1EMISSAO: undefined,
    items: []
  };
};

export interface ControlePesoProduto {
  produto: string;
  quantidade: number;
  peso: number;
  prateleira: string;
  inform: string;
  UR: number;
}